import { render } from "./StakeHealth.vue?vue&type=template&id=ba8d034a&scoped=true"
import script from "./StakeHealth.vue?vue&type=script&lang=js"
export * from "./StakeHealth.vue?vue&type=script&lang=js"

import "./StakeHealth.vue?vue&type=style&index=0&id=ba8d034a&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba8d034a"],['__file',"resources/js/components/StakeHealth.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ba8d034a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ba8d034a', __exports__)) {
    api.reload('ba8d034a', __exports__)
  }
  
  module.hot.accept("./StakeHealth.vue?vue&type=template&id=ba8d034a&scoped=true", () => {
    api.rerender('ba8d034a', render)
  })

}


export default __exports__